import Vue from "vue";
import Router from "vue-router";
import Home from "@/Pages/Home/Home.vue";
import ISP from "@/Pages/ISP/ISP.vue";
import Enterprise from "@/Pages/Enterprise/Enterprise.vue";
import Retail from "@/Pages/Retail/Retail.vue";
import CloudSaasAccerlation from "@/Pages/CloudSaasAccerlation/CloudSaasAccerlation.vue";
import CloudXpressConnect from "@/Pages/CloudXpressConnect/CloudXpressConnect.vue";
import GlobalAppAccess from "@/Pages/GlobalAppAccess/GlobalAppAccess.vue";
import MobileClient from "@/Pages/MobileClient/MobileClient.vue";
import Hardware from "@/Pages/Hardware/Hardware.vue";
import R100X6 from "@/Pages/Hardware/R100X6.vue";
import R200X6 from "@/Pages/Hardware/R200X6.vue";
import R500X8S from "@/Pages/Hardware/R500X8S.vue";
import D100AWL5 from "@/Pages/Hardware/D100AWL5.vue";
import D100 from "@/Pages/Hardware/D100.vue";
import S200 from "@/Pages/Hardware/S200.vue";
import S50 from "@/Pages/Hardware/S50.vue";
import A55 from "@/Pages/Hardware/A55.vue";
import D200X4 from "@/Pages/Hardware/D200X4.vue";
import V100 from "@/Pages/Hardware/V100.vue";
import Diff from "@/Pages/Hardware/Diff.vue";
import All from "@/Pages/Customer/All.vue";
import CustomerDetail from "@/Pages/CustomerDetail/CustomerDetail.vue";
import Partner from "@/Pages/Partner/Partner.vue";
import SDWAN from "@/Pages/SD-WAN/SD-WAN.vue";
import WhitePage from "@/Pages/WhitePage/WhitePage.vue";
import M100 from "@/Pages/M100/M100.vue";
import Support from "@/Pages/Support/Support.vue";
import Overview from "@/Pages/Overview/Overview";
import ExpertTeam from "@/Pages/ExpertTeam/ExpertTeam";
import Awards from "@/Pages/Awards/Awards";
import News from "@/Pages/News/News";
import NewDetail from "@/Pages/NewDetail/NewDetail";
import N1 from "@/Pages/NewDetail/N1";
import N2 from "@/Pages/NewDetail/N2";

import DownloadPage from "@/Pages/Download/Download.vue";
import DownloadM100Page from "@/Pages/Download/DownloadM100.vue";
import DownloadYATPage from "@/Pages/Download/DownloadYAT.vue";
import DownloadSasePage from "@/Pages/Download/DownloadSase.vue";
import DownloadNtToolPage from "@/Pages/Download/DownloadNtTool.vue";

Vue.use(Router);

export default new Router({
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: "/",
            name: "Home",
            component: Home,
        },
        {
            path: "/ISP",
            name: "ISP",
            component: ISP,
        },
        {
            path: "/Enterprise",
            name: "Enterprise",
            component: Enterprise,
        },
        {
            path: "/Retail",
            name: "Retail",
            component: Retail,
        },
        {
            path: "/CloudSaasAccerlation",
            name: "CloudSaasAccerlation",
            component: CloudSaasAccerlation,
        },
        {
            path: "/CloudXpressConnect",
            name: "CloudXpressConnect",
            component: CloudXpressConnect,
        },
        {
            path: "/GlobalAppAccess",
            name: "GlobalAppAccess",
            component: GlobalAppAccess,
        },
        {
            path: "/MobileClient",
            name: "MobileClient",
            component: MobileClient,
        },
        {
            path: "/Hardware",
            name: "Hardware",
            component: Hardware,
            redirect: "/Hardware/R100-X6",
            children: [
                {
                    path: "/Hardware/R100-X6",
                    component: R100X6,
                },
                {
                    path: "/Hardware/R200-X6",
                    component: R200X6,
                },
                {
                    path: "/Hardware/R500-X8S",
                    component: R500X8S,
                },
                {
                    path: "/Hardware/D100-AWL5",
                    component: D100AWL5,
                },
                {
                    path: "/Hardware/D200-X4",
                    component: D200X4,
                },
                {
                    path: "/Hardware/D100",
                    component: D100,
                },
                {
                    path: "/Hardware/S200",
                    component: S200,
                },
                {
                    path: "/Hardware/S50",
                    component: S50,
                },
                {
                    path: "/Hardware/A55",
                    component: A55,
                },
                {
                    path: "/Hardware/V100",
                    component: V100,
                },
                {
                    path: "/Hardware/Diff",
                    component: Diff,
                },
            ],
        },
        {
            path: "/CustomerCaseStudy",
            name: "CustomerCaseStudy",
            component: All,
        },
        {
            path: "/CustomerDetail/:id",
            name: "CustomerDetail",
            component: CustomerDetail,
        },
        {
            path: "/Partner",
            name: "Partner",
            component: Partner,
        },
        {
            path: "/SDWAN",
            name: "SDWAN",
            component: SDWAN,
        },
        {
            path: "/WhitePager",
            name: "WhitePager",
            component: WhitePage,
        },
        {
            path: "/Download",
            name: "Download",
            component: DownloadPage,
        },
        {
            path: "/services/download",
            redirect: "/Download",
        },
        {
            path: "/Download-M100",
            name: "Download-M100",
            component: DownloadM100Page,
        },
        {
            path: "/services/download/m100",
            redirect: "/Download-M100",
        },
        {
            path: "/Download-YAT",
            name: "Download-YAT",
            component: DownloadYATPage,
        },
        {
            path: "/services/download/yat",
            redirect: "/Download-YAT",
        },
        {
            path: "/Download-Sase",
            name: "Download-Sase",
            component: DownloadSasePage,
        },
        {
            path: "/services/download/sase",
            redirect: "/Download-Sase",
        },
        {
            path: "/Download-Tool",
            name: "Download-Tool",
            component: DownloadNtToolPage,
        },
        {
            path: "/Support",
            name: "Support",
            component: Support,
        },
        {
            path: "/Overview",
            name: "Overview",
            component: Overview,
        },
        {
            path: "/ExpertTeam",
            name: "ExpertTeam",
            component: ExpertTeam,
        },
        {
            path: "/Awards",
            name: "Awards",
            component: Awards,
        },
        {
            path: "/News",
            name: "News",
            component: News,
        },
        {
            path: "/NewDetail",
            name: "NewDetail",
            component: NewDetail,
            children: [
                {
                    path: "/NewDetail/1",
                    component: N1,
                },
                {
                    path: "/NewDetail/2",
                    component: N2,
                },
            ],
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js